enum CollectionPermissions {
  ClientUpload = 'client:upload'
}

export default CollectionPermissions;
